/* The key control (key selector K-S2, #2764; spec §2, §5) */
.keySelect {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1_5);
  width: 284px;
  max-width: 100%;
}

.readout {
  display: flex;
  align-items: center;
  justify-content: space-between;
  min-height: 44px;
}

.name {
  font-size: var(--tuna-typography-fontSize-2xl);
  font-weight: 600;
  color: var(--tuna-palette-text-primary);
}

.unset {
  color: var(--tuna-palette-text-secondary);
  font-weight: 500;
}

.textButton {
  min-height: 44px;
  padding: 0 var(--tuna-spacing-1);
  border: 0;
  border-radius: var(--tuna-shape-borderRadius);
  background: none;
  color: var(--tuna-palette-primary-main);
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}

.textButton:hover {
  background-color: var(--tuna-palette-action-hover);
}

.spell {
  align-self: flex-start;
  min-height: 32px;
}

.grid {
  display: grid;
  grid-template-columns: repeat(6, minmax(44px, 1fr));
  gap: var(--tuna-spacing-0_5);
}

.cell {
  min-height: 44px;
  padding: 0;
  border: 1px solid var(--tuna-palette-text-disabled);
  border-radius: var(--tuna-shape-borderRadius);
  background: transparent;
  color: var(--tuna-palette-text-primary);
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}

/* Selected: primary fill with its contrast text (about 7:1 light, 6:1 dark), so the fill is not the only cue */
.cell[aria-checked='true'] {
  border-color: var(--tuna-palette-primary-main);
  background-color: var(--tuna-palette-primary-main);
  color: var(--tuna-palette-primary-contrastText);
}

.cell:focus-visible,
.segment:focus-visible,
.textButton:focus-visible,
.moreOption:focus-visible {
  outline: 2px solid var(--tuna-palette-primary-main);
  outline-offset: 2px;
}

.scaleRow {
  display: flex;
  min-height: 44px;
  border: 1px solid var(--tuna-palette-text-disabled);
  border-radius: var(--tuna-shape-borderRadius);
  overflow: hidden;
}

.segments {
  display: flex;
  flex: 2 1 0;
}

.segment {
  flex: 1 1 0;
  min-height: 44px;
  border: 0;
  border-left: 1px solid var(--tuna-palette-text-disabled);
  background: transparent;
  color: var(--tuna-palette-text-primary);
  font: inherit;
  cursor: pointer;
}

.segments .segment:first-child {
  border-left: 0;
}

.segment[aria-checked='true'],
.more[data-selected='true'],
.more[aria-pressed='true'] {
  background-color: var(--tuna-palette-action-selected);
  color: var(--tuna-palette-primary-main);
  font-weight: 700;
  box-shadow: inset 0 -2px 0 var(--tuna-palette-primary-main);
}

.more {
  flex: 1.25 1 0;
}

.moreHeader {
  display: flex;
  align-items: center;
  gap: var(--tuna-spacing-1);
}

.moreTitle {
  margin: 0;
  font-size: var(--tuna-typography-body1-fontSize);
  font-weight: 600;
  color: var(--tuna-palette-text-primary);
}

.moreList {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1);
}

.groupLabel {
  margin: var(--tuna-spacing-1) 0 var(--tuna-spacing-0_5);
  font-size: var(--tuna-typography-caption-fontSize);
  font-weight: 600;
  text-transform: uppercase;
  color: var(--tuna-palette-text-secondary);
}

.moreOption {
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 48px;
  padding: 0 var(--tuna-spacing-1_5);
  border: 0;
  border-radius: var(--tuna-shape-borderRadius);
  background: none;
  color: var(--tuna-palette-text-primary);
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.moreOption[aria-checked='true'] {
  background-color: var(--tuna-palette-action-selected);
  color: var(--tuna-palette-primary-main);
  font-weight: 600;
}
